import React, { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import './set-context.scss';
import { loginMessages, useRubricheLogic } from 'azshared';
import { LoginContainer } from '../login-container/login-container';
import { Card, CardSize } from '../../../components/card/card';
import { AppButton, AppButtonType } from '../../../components/buttons/app-button';
import { AppSearchableSelect, AppSearchableSelectOption } from '../../../components/select/app-searchable-select';
import { SingleValue } from 'react-select';
import { BannerCookiePolicy } from 'src/components/banner-cookie-policy/banner-cookie-policy';

export const SetContext = () => {
  const { formatMessage } = useIntl();

  const { rubriche, rubrica, rubricaLabel, setRubricaValue, setRubricaLabel, onSubmit, rubricaLogicEnabled } = useRubricheLogic();

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      onSubmit();
    },
    [onSubmit]
  );

  const setValue = useCallback(
    (option: SingleValue<AppSearchableSelectOption>) => {
      setRubricaValue(option?.value as string);
      setRubricaLabel(option?.label as string);
    },
    [setRubricaLabel, setRubricaValue]
  );

  const options: AppSearchableSelectOption[] = useMemo(() => {
    return rubriche.map((r) => ({ value: r.codiceRubrica ?? '', label: r.nominative ?? '' }));
  }, [rubriche]);

  const value = useMemo(() => {
    return {
      value: rubrica,
      label: rubricaLabel
    };
  }, [rubrica, rubricaLabel]);

  return (
    <>
      <LoginContainer>
        <div className={'context-card'}>
          <Card subtitle={formatMessage(loginMessages.setContextTitle)} sizeVariant={options.length < 10 ? CardSize.RUBRICA : CardSize.MEDIUM}>
            <form onSubmit={handleSubmit}>
              <AppSearchableSelect
                placeholder={formatMessage(loginMessages.selectRubrica)}
                value={value}
                options={options}
                onChange={setValue}
                useDefaultStyles={false}
                style={customStyles(options.length)}
                useOnlyList={options.length < 10}
              />
              <div className='button'>
                <AppButton
                  loading={!rubriche?.length}
                  type={AppButtonType.SUBMIT}
                  label={formatMessage(loginMessages.loginButton)}
                  disabled={!rubricaLogicEnabled || !rubrica}
                  className={options.length < 10 ? 'submit-button' : ''}
                />
              </div>
            </form>
          </Card>
        </div>
      </LoginContainer>
      <BannerCookiePolicy />
    </>
  );
};

const customStyles = (optionsLength: number) => ({
  input: (provided: any) => ({
    ...provided,
    fontFamily: ['Futura-Book', 'sans-serif'],
    fontSize: '0.75rem',
    lineHeight: '0.875rem',
    color: '#8F95B2'
  }),
  option: (provided: any) => ({
    ...provided,
    fontFamily: ['Futura-Book', 'sans-serif'],
    fontSize: '0.75rem',
    lineHeight: '0.875rem',
    color: '#8F95B2'
  }),
  placeholder: (provided: any) => ({
    ...provided,
    fontSize: '11px'
  }),
  control: (provided: any) => ({
    ...provided,
    border: '1px solid #D8DAE5',
    display: optionsLength < 10 ? 'none' : 'flex', // Hide the input to get the list only
    borderRadius: '1.4285rem'
  }),
  menu: (provided: any) => ({
    ...provided,
    padding: 0,
    marginTop: '5px'
  })
});
